<template>
  <div class="page-container">
    <iframe
      class="customerIframe"
      name="customerIframe"
      ref="customerIframeRef"
      :src="url"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  created() {
    window.document.title = '客服中心-在线咨询';
  },
  data () {
    return {
      url: 'https://tb.53kf.com/code/app/10236926/8',
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
}
.customerIframe {
  width: 100%;
  height: 100%;
}
</style>
